<div
  class="container mt-2 mb-5"
  style="
    width: 100% !important;
    padding: 0 0.35rem 0 0.35rem !important ;
    max-width: max-content;
  "
>
  <div style="overflow: hidden" class="mb-3">
    <h4 class="float-left mb-0" style="margin-top: 8px" i18n>Meus Pedidos</h4>
    <table class="float-right form-group mb-0">
      <tr>
        <td class="align-middle">
          <span class="info1">Status:&nbsp;</span>
        </td>
        <td>
          <div class="form-group mb-0">
            <div class="btn-group btn-group-toggle" data-toggle="buttons">
              <label
                routerLink="/pedidos"
                [queryParams]="{ page: 'ABERTO' }"
                [class.active]="page == 'ABERTO'"
                class="btn btn-primary"
                i18n
              >
                <input
                  type="radio"
                  name="options"
                  id="option1"
                  autocomplete="off"
                  checked
                />
                DIGITAÇÃO
              </label>
              <label
                *ngIf="
                  SITE.salvaCheckout && this.initProvider.usuario.integra_pedido
                "
                routerLink="/pedidos"
                [queryParams]="{ page: 'SALVO' }"
                [class.active]="page == 'SALVO'"
                class="btn btn-primary"
                i18n
              >
                <input
                  type="radio"
                  name="options"
                  id="option1"
                  autocomplete="off"
                  checked
                />
                ORÇAMENTO
              </label>
              <label
                routerLink="/pedidos"
                [queryParams]="{ page: 'EM_ANDAMENTO' }"
                [class.active]="page == 'EM_ANDAMENTO'"
                class="btn btn-primary"
                i18n
              >
                <input
                  type="radio"
                  name="options"
                  id="option2"
                  autocomplete="off"
                />
                ANDAMENTO
              </label>
              <label
                routerLink="/pedidos"
                [queryParams]="{ page: 'CONCLUÍDO' }"
                [class.active]="page == 'CONCLUÍDO'"
                class="btn btn-primary"
                i18n
              >
                <input
                  type="radio"
                  name="options"
                  id="option3"
                  autocomplete="off"
                />
                CONCLUÍDO
              </label>
              <label
                routerLink="/pedidos"
                [queryParams]="{ page: 'TODOS' }"
                [class.active]="page == 'TODOS'"
                class="btn btn-primary"
                i18n
              >
                <input
                  type="radio"
                  name="options"
                  id="option4"
                  autocomplete="off"
                />
                TODOS
              </label>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
  <form
    (ngSubmit)="onSubmitSearch()"
    [formGroup]="formSearch"
    class="formSearch"
  >
    <div class="row">
      <div class="col-lg-3">
        <div class="form-group">
          <label i18n>Data</label>
          <input
            type="text"
            class="form-control form-control-sm"
            bsDaterangepicker
            formControlName="data"
            placement="bottom left"
            [bsConfig]="{
              isAnimated: true,
              dateInputFormat: 'DD-MM-YYYY',
              ranges: ranges
            }"
          />
        </div>
      </div>
      <div *ngIf="isGestor" class="col-lg-4">
        <div class="form-group">
          <label i18n>Usuário</label>
          <input
            [(ngModel)]="typingUsuario"
            [ngModelOptions]="{ standalone: true }"
            [typeaheadAsync]="true"
            [typeahead]="usuarios"
            typeaheadOptionField="nome"
            isAnimated="true"
            (typeaheadOnSelect)="onSelectUsuario($event)"
            (typeaheadNoResults)="typeaheadNoResultsUsuario($event)"
            id="usuario"
            autocomplete="off"
            class="form-control form-control-sm"
          />
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label>{{ SITE.labelCliente }}</label>
          <input
            [(ngModel)]="typingCliente"
            [ngModelOptions]="{ standalone: true }"
            [typeaheadAsync]="true"
            [typeahead]="clientes"
            typeaheadOptionField="{{ 'nome' }}"
            isAnimated="true"
            (typeaheadOnSelect)="onSelectCliente($event)"
            (typeaheadNoResults)="typeaheadNoResults($event)"
            id="cliente"
            autocomplete="off"
            class="form-control form-control-sm"
          />
        </div>
      </div>
      <div
        *ngIf="page != 'ABERTO' && page != 'TODOS' && page != 'SALVO'"
        class="col-lg-3"
      >
        <div class="form-group">
          <label i18n>Status ERP</label>
          <select
            name="statusERP"
            formControlName="statusERP"
            class="form-control form-control-sm"
          >
            <option value=""></option>
            <option *ngFor="let s of statusERPs" value="{{ s }}">
              {{ s }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-lg-1">
        <div class="form-group">
          <button
            id="btnFormSearch"
            class="btn btn-sm btn-secondary"
            style="margin-top: 22px"
          >
            <i class="{{ SITE.iconSearch }}"></i>
          </button>
        </div>
      </div>
    </div>
  </form>
  <div class="row">
    <div class="col-lg-12">
      <div *ngIf="empty" class="row mt-3">
        <div class="col-lg-6 offset-lg-3 text-center">
          <h5 i18n>Nenhum item encontrado!</h5>
          <img src="assets/empty.png" class="img-fluid" />
        </div>
      </div>
      <div *ngIf="!empty" class="table-responsive">
        <table
          *ngIf="page == 'ABERTO' || page == 'TODOS' || page == 'SALVO'"
          class="table table-hover table-sm"
        >
          <thead>
            <tr>
              <th scope="col">Id</th>
              <th scope="col" i18n>Usuário</th>
              <th scope="col" i18n> Data do pedido</th>
              <th scope="col" i18n>Pedido</th>
              <th scope="col">{{ SITE.labelCliente }}</th>
              <th scope="col">{{ SITE.labelFilial }}</th>
              <th scope="col">{{ SITE.labelTabela }}</th>
              <th scope="col">Status</th>
              <!-- <th scope="col" i18n>Aprovação Cliente</th> -->
              <th
                *ngIf="
                  SITE.precoDivergenteTabelaMin != null &&
                  SITE.precoDivergenteTabelaIdeal != null
                "
                scope="col"
                i18n
              >
                Preço divergente
              </th>
              <th scope="col" i18n>Itens</th>
              <th scope="col" i18n>R$&nbsp;Valor</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let p of pedidos"
              [class.table-warning]="p.integracaoError"
            >
              <td class="align-middle">
                {{ p.id }}
                <button
                  *ngIf="p.integracaoError"
                  class="btn btn-warning"
                  style="padding: 2px !important"
                  tooltip="{{ p.integracaoMessage }}"
                >
                  <i class="icofont-warning"></i>
                </button>
                <button
                  *ngIf="p.salvoCheckout"
                  class="btn btn-success"
                  style="padding: 2px !important"
                  tooltip="Pedido salvo!"
                >
                  <i class="icofont-check"></i>
                </button>
              </td>
              <td class="align-middle" data-label="Usuário">
                {{ p.usuario.id }} - {{ p.usuario.nome }}
              </td>
              <td class="align-middle data-adjust" data-label="Data">
                {{ p.data }}
              </td>
              <td class="align-middle" data-label="Código">
                <div
                  style="font-size: 0.8rem !important"
                  *ngFor="let c of p.clientes; let i = index"
                  >{{ c.id }}</div
                >
              </td>
              <td class="align-middle" data-label="Cliente">
                <div *ngFor="let pc of p.clientes">
                  {{ pc.cliente[SITE.identificacaoCliente] }} -
                  {{ pc.cliente.nome }}
                </div>
              </td>
              <td class="align-middle" data-label="Filial">
                {{ p.filial.codigo }} - {{ p.filial.descricao }}
              </td>
              <td class="align-middle" data-label="Tabela">
                {{ p.tabela.codigo }} - {{ p.tabela.descricao }}
              </td>
              <td class="align-middle">
                <a
                  href="javascript:void(0);"
                  data-toggle="modal"
                  data-target="#pedidoModalInfo"
                  (click)="showPedidoFinalizado(p)"
                  title="Informações"
                  i18n-title
                  >{{
                    p.infos
                      ? p.infos.length > 0
                        ? p.infos[p.infos.length - 1].statusDescricao
                        : ""
                      : ""
                  }}</a
                >
              </td>
              <!-- <td class="align-middle" data-label="Aprovação Cliente">
                <div
                  *ngIf="p.clientes.length > 1; else elseBlockAprvCli"
                  class="dropdown"
                >
                  <a
                    href="#"
                    id="dropdownMenuAprovaCliente"
                    data-toggle="dropdown"
                    [innerHtml]="
                      pedidoService.getClienteAprovadoDescr(p.clientes)
                    "
                  ></a>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuAprovaCliente"
                    style="cursor: pointer"
                  >
                    <a
                      *ngFor="let pc of p.clientes"
                      (click)="getLinkAprovaCliente(p, pc.id)"
                      class="dropdown-item"
                    >
                      {{ pc.cliente[SITE.identificacaoCliente] }} -
                      {{ pc.cliente.nome }}
                      <span *ngIf="pc.aprovado" style="color: green"
                        ><b>- OK</b></span
                      >
                    </a>
                  </div>
                </div>
                <ng-template #elseBlockAprvCli>
                  <a
                    (click)="getLinkAprovaCliente(p, p.clientes[0].id)"
                    [innerHtml]="
                      pedidoService.getClienteAprovadoDescr(p.clientes)
                    "
                    style="cursor: pointer"
                  ></a>
                </ng-template>
              </td> -->
              <td
                *ngIf="
                  SITE.precoDivergenteTabelaMin != null &&
                  SITE.precoDivergenteTabelaIdeal != null
                "
                class="align-middle"
                data-label="Itens"
              >
                <span
                  *ngIf="p.precoDivergenteStatus == 2; else elsePrecoDiv"
                  tooltip="Aguarde aprovação do administrador"
                  i18n-tooltip
                  style="color: orange"
                  ><b i18n>PENDENTE</b></span
                >
                <ng-template #elsePrecoDiv>
                  <span style="color: blue"><b i18n>APROVADO</b></span>
                </ng-template>
              </td>
              <td class="align-middle" data-label="Itens">
                {{ p.quantidade }}
              </td>
              <td class="align-middle money-green" data-label="R$ Valor">
                {{ p.total | currency : "BRL" : "" }}
              </td>
              <td class="align-middle">
                <div class="btn-group">
                  <button
                    (click)="confirmDel(p)"
                    data-toggle="modal"
                    data-target="#confirmDelModal"
                    title="Excluir"
                    i18n-title
                    class="btn btn-outline-primary buttonLeft"
                  >
                    <i class="icofont-trash"></i>
                  </button>
                  <button
                    (click)="showPedido(p)"
                    data-toggle="modal"
                    data-target="#pedidoModal"
                    title="Visualizar"
                    i18n-title
                    class="btn btn-outline-primary buttonMiddle"
                  >
                    <i class="icofont-search-document"></i>
                  </button>
                  <div
                    *ngIf="p.clientes.length > 1; else elseBlockPrint1"
                    class="dropdown"
                  >
                    <button
                      class="btn btn-outline-primary dropdown-toggle buttonMiddle"
                      style="min-height: -webkit-fill-available;"
                      id="dropdownMenuLink"
                      data-toggle="dropdown"
                      title="Imprimir"
                      i18n-title
                    >
                      <i class="icofont-printer"></i>
                    </button>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuLink"
                      style="cursor: pointer"
                    >
                      <a
                        *ngFor="let pc of p.clientes"
                        (click)="printPedidoPdf(pc.pedido)"
                        class="dropdown-item"
                      >
                        {{ pc.cliente[SITE.identificacaoCliente] }} -
                        {{ pc.cliente.nome }}
                      </a>
                    </div>
                  </div>
                  <ng-template #elseBlockPrint1>
                    <button
                      class="btn btn-outline-primary buttonMiddle"
                      (click)="printPedidoPdf(p.clientes[0].id)"
                      title="Imprimir"
                      i18n-title
                      [class.spinner]="loadPdf"
                      [disabled]="loadPdf"
                    >
                      <i class="icofont-printer"></i>
                      <!-- <ng-template #elseBlock>loading</ng-template> -->
                    </button>
                  </ng-template>
                  <button
                    *ngIf="page !== 'TODOS'"
                    (click)="selectPedido(p)"
                    title="Editar"
                    i18n-title
                    class="btn btn-outline-primary buttonMiddle"
                  >
                    <i class="icofont-ui-edit"></i>
                  </button>
                  <button
                    (click)="download(p)"
                    title="Download"
                    i18n-title
                    class="btn btn-outline-primary buttonMiddle"
                    [class.spinner]="loadImgs"
                    [disabled]="loadImgs"
                  >
                    <mat-icon>download</mat-icon>
                  </button>
                  <button
                    (click)="redirectCopyPedido(p)"
                    title="Copiar"
                    i18n-title
                    class="btn btn-outline-primary buttonRight"
                  >
                    <i class="icofont-copy"></i>
                  </button>
                  <button
                    *ngIf="page != 'TODOS'"
                    (click)="selectPedidoCheckout(p)"
                    title="Finalizar"
                    i18n-title
                    class="btn btn-outline-primary buttonRight"
                  >
                    <i class="icofont-check-circled"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <table
          *ngIf="page == 'EM_ANDAMENTO' || page == 'CONCLUÍDO'"
          class="table table-hover table-sm"
        >
          <thead>
            <tr>
              <th scope="col" i18n>Pedido</th>
              <th scope="col">Id</th>
              <th scope="col" i18n>Usuário</th>
              <th scope="col" i18n>Data do Pedido</th>
              <th scope="col">{{ SITE.labelCliente }}</th>
              <th scope="col">{{ SITE.labelFilial }}</th>
              <th scope="col">{{ SITE.labelTabela }}</th>
              <th scope="col" i18n>Status</th>
              <th scope="col" i18n>Itens</th>
              <th scope="col" i18n>R$&nbsp;Valor</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of pedidos">
              <td class="align-middle">{{ p.pedido }}</td>
              <td class="align-middle">{{ p.id }}</td>
              <td class="align-middle">
                {{ p.usuario.id }} - {{ p.usuario.nome }}
              </td>
              <td class="align-middle data-adjust">
                {{ p.data }}
              </td>
              <td class="align-middle">
                {{ p.cliente[SITE.identificacaoCliente] }} -
                {{ p.cliente.nome }}
              </td>
              <td class="align-middle">
                {{ p.filial.codigo }} - {{ p.filial.descricao }}
              </td>
              <td class="align-middle">
                {{ p.tabela.codigo }} - {{ p.tabela.descricao }}
              </td>
              <td class="align-middle">
                <a
                  href="javascript:void(0);"
                  data-toggle="modal"
                  data-target="#pedidoModalInfo"
                  (click)="showPedidoFinalizado(p)"
                  title="Informações"
                  i18n-title
                  >{{
                    p.infos ? p.infos[p.infos.length - 1].statusDescricao : ""
                  }}</a
                >
              </td>
              <td class="align-middle">{{ p.quantidade }}</td>
              <td class="align-middle money-green">
                {{ p.total | currency : "BRL" : "" }}
              </td>
              <td class="align-middle">
                <div class="btn-group">
                  <button
                    (click)="showPedidoFinalizado(p)"
                    data-toggle="modal"
                    data-target="#pedidoModalFinalizado"
                    title="Visualizar"
                    i18n-title
                    class="btn btn-outline-primary buttonLeft"
                  >
                    <i class="icofont-search-document"></i>
                  </button>
                  <!-- <button
                    *ngIf="initProvider.usuario.integra_pedido"
                    (click)="selectPedido(p)"
                    title="Editar"
                    i18n-title
                    class="btn btn-outline-primary buttonMiddle"
                  >
                    <i class="icofont-ui-edit"></i>
                  </button> -->
                  <button
                    class="btn btn-outline-primary buttonMiddle"
                    (click)="printPedidoExcel(p)"
                    title="Excel"
                    i18n-title
                  >
                    <i class="icofont-table"></i>
                  </button>
                  <button
                    class="btn btn-outline-primary buttonMiddle"
                    (click)="redirectToRastreio(p)"
                    title="Rastreio"
                    i18n-title
                  >
                    <mat-icon>local_shipping</mat-icon>
                  </button>
                  <button
                    class="btn btn-outline-primary buttonRight"
                    (click)="printPedidoPdf(p.pedido)"
                    title="Imprimir"
                    i18n-title
                    [class.spinner]="loadPdf"
                    [disabled]="loadPdf"
                  >
                    <i class="icofont-printer"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="pageable && !empty" class="row">
        <div class="col-lg-4 pl-0">
          <label i18n
            >Página {{ pageable.number + 1 }} de
            {{ pageable.totalPages }}</label
          >
        </div>
        <div class="col-lg-4">
          <pagination
            [totalItems]="pageable.totalElements"
            [maxSize]="5"
            [disabled]="pedidoService.loading"
            [(ngModel)]="pageNumber"
            (pageChanged)="pageChanged($event)"
            previousText="&lsaquo;"
            nextText="&rsaquo;"
          >
          </pagination>
        </div>
        <div class="col-lg-4 text-right pr-0">
          <label i18n>{{ pageable.totalElements }} registros encontrados</label>
        </div>
      </div>
    </div>
  </div>
  <input type="text" id="inputLinkAprovaCliente" style="opacity: 0" />
</div>
<div
  class="modal fade"
  id="pedidoModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="pedidoModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl" role="document">
    <div *ngIf="pedido" class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>Pedido #{{ pedido.pedido }}</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding: 5px !important">
        <div class="row mt-2">
          <div class="col-sm-6 pr-0">
            <label
              ><input
                type="checkbox"
                value="true"
                [(ngModel)]="pedidoClienteSelected.todos"
                (change)="changePedidoClienteSelectedTodos()"
              />
              {{ SITE.labelCliente }}</label
            ><br />
            <div *ngFor="let pc of pedido.clientes">
              <label style="font-size: inherit">
                <input
                  type="checkbox"
                  value="true"
                  [(ngModel)]="pedidoClienteSelected[pc.cliente.id]"
                  (change)="changePedidoClienteSelected()"
                />
                {{ pc.cliente[SITE.identificacaoCliente] }} -
                {{ pc.cliente.nome }}, {{ pc.cliente.documento }}
              </label>
            </div>
          </div>
          <div class="col-sm-3 pr-0">
            <label>{{ SITE.labelFilial }}</label
            ><br />
            {{ pedido.filial.codigo }} - {{ pedido.filial.descricao }}
          </div>
          <div class="col-sm-3">
            <label>{{ SITE.labelTabela }}</label
            ><br />
            {{ pedido.tabela.codigo }} - {{ pedido.tabela.descricao }}
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="row mt-2">
          <div *ngIf="pedido.data" class="col-sm-2">
            <label i18n>Data</label><br />
            {{ pedido.data }}
          </div>
          <div *ngIf="pedido.dataEntrega" class="col-sm-2">
            <label i18n>Data Entrega</label><br />
            {{ pedido.dataEntrega }}
          </div>
          <div class="col-sm-2">
            <label>Status</label><br />
            {{ pedido.status }}
          </div>
          <div class="col-sm-2">
            <label i18n>Quantidade</label><br />
            {{ quantidadeTotal }}
          </div>
          <div *ngIf="pedido.formaPagamento" class="col-sm-3">
            <label i18n>Forma pagamento</label><br />
            {{ pedido.formaPagamento.codigo }} -
            {{ pedido.formaPagamento.descricao }}
          </div>
          <div class="col-sm-3">
            <label i18n>Tipo</label><br />
            {{ pedido.tipo.tipo }} - {{ pedido.tipo.descricao }}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-6">
            <div *ngIf="pedido.observacao">
              <label i18n>Observações</label><br />
              {{ pedido.observacao }}
            </div>
          </div>
          <div class="col-sm-6 pl-0">
            <div class="row mb-1 pl-0" *ngIf="this.SITE.mostraImpostoDetalhado">
              <div class="col-8 text-right pl-0" i18n>Subtotal:</div>
              <div class="col-4 pl-0">{{ subTotal | currency : "BRL" }}</div>
            </div>
            <div *ngIf="acrescimoTotal" class="row mb-1 pl-0">
              <div class="col-8 text-right" i18n>+ Acréscimos:</div>
              <div class="col-4">
                <span>{{ acrescimoTotal | currency : "BRL" }}</span>
              </div>
            </div>
            <div *ngIf="descontoTotal" class="row mb-1 pl-0">
              <div class="col-8 text-right" i18n>- Descontos:</div>
              <div class="col-4">
                <span>{{ descontoTotal | currency : "BRL" }}</span>
              </div>
            </div>
            <div
              *ngIf="impostosTotal && this.SITE.mostraImpostoDetalhado"
              class="row mb-1 pl-0"
              style="color: red"
            >
              <div class="col-8 text-right" i18n>+ Impostos:</div>
              <div class="col-4">
                <span>{{ impostosTotal | currency : "BRL" }}</span>
              </div>
            </div>
            <div *ngIf="pedido.freteValor" class="row mb-1" style="color: red">
              <div class="col-8 text-right" i18n>+ Frete:</div>
              <div class="col-4">
                <span>{{ pedido.freteValor | currency : "BRL" }}</span>
              </div>
            </div>
            <div class="row mb-1 pl-0">
              <div class="col-8 text-right pl-0" i18n>Valor total:</div>
              <div class="col-4 pl-0" style="color: green; font-weight: bold">
                {{ valorTotal | currency : "BRL" }}
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-5"></div>
          <div class="col-sm-7"></div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="mt-2" [innerHtml]="tablePedidoAberto"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade"
  id="pedidoModalFinalizado"
  tabindex="-1"
  role="dialog"
  aria-labelledby="pedidoModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl" role="document">
    <div
      *ngIf="pedido && pedido.status != 'ABERTO' && pedido.status != 'TODOS'"
      class="modal-content"
    >
      <div class="modal-header">
        <h5 class="modal-title" i18n>Pedido #{{ pedido.pedido }}</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding: 5px !important">
        <div class="row mt-2">
          <div class="col-sm-6 pr-0">
            <label>{{ SITE.labelCliente }}</label
            ><br />
            {{ pedido.cliente[SITE.identificacaoCliente] }} -
            {{ pedido.cliente.nome }}, {{ pedido.cliente.documento }}
          </div>
          <div class="col-sm-3 pr-0">
            <label>{{ SITE.labelFilial }}</label
            ><br />
            {{ pedido.filial.codigo }} - {{ pedido.filial.descricao }}
          </div>
          <div class="col-sm-2">
            <label>{{ SITE.labelTabela }}</label
            ><br />
            {{ pedido.tabela.codigo }} - {{ pedido.tabela.descricao }}
          </div>
          <div class="col-sm-1">
            <button
              title="duplicar pedido"
              style="border: none; background: transparent"
              (click)="duplicaPedido(pedido)"
            >
              <img
                src="assets/duplicate.svg"
                width="20"
                style="margin-right: 7px"
              />
            </button>
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="row mt-2">
          <div class="col-sm-2">
            <label i18n>Data</label><br />
            {{ pedido.data }}
          </div>
          <div *ngIf="pedido.dataEntrega" class="col-sm-2">
            <label i18n>Data Entrega</label><br />
            {{ pedido.dataEntrega }}
          </div>
          <div class="col-sm-2">
            <label>Status</label><br />
            {{ pedido.infos[pedido.infos.length - 1].statusDescricao }}
          </div>
          <div class="col-sm-2">
            <label i18n>Quantidade</label><br />
            {{ pedido.quantidade }}
          </div>
          <div class="col-sm-3">
            <label>Forma pagamento</label><br />
            {{ pedido.formaPagamento.codigo }} -
            {{ pedido.formaPagamento.descricao }}
          </div>
          <div class="col-sm-3">
            <label i18n>Tipo</label><br />
            {{ pedido.tipo.tipo }} - {{ pedido.tipo.descricao }}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-6">
            <div *ngIf="pedido.observacao">
              <label i18n>Observações</label><br />
              {{ pedido.observacao }}
            </div>
          </div>
          <div class="col-sm-6 pl-0">
            <div class="row mb-1 pl-0" *ngIf="this.SITE.mostraImpostoDetalhado">
              <div class="col-8 text-right pl-0">Subtotal:</div>
              <div class="col-4 pl-0">
                {{ pedido.subtotal | currency : "BRL" }}
              </div>
            </div>
            <div
              *ngIf="pedido.acrescimo"
              class="row mb-1 pl-0"
              style="color: red"
            >
              <div class="col-8 text-right" i18n>+ Acréscimos:</div>
              <div class="col-4">
                <span>{{ pedido.acrescimo | currency : "BRL" }}</span>
              </div>
            </div>
            <div
              *ngIf="pedido.desconto"
              class="row mb-1 pl-0"
              style="color: blue"
            >
              <div class="col-8 text-right" i18n>- Descontos:</div>
              <div class="col-4">
                <span>{{ pedido.desconto | currency : "BRL" }}</span>
              </div>
            </div>
            <div
              *ngIf="pedido.impostos && this.SITE.mostraImpostoDetalhado"
              class="row mb-1 pl-0"
              style="color: red"
            >
              <div class="col-8 text-right" i18n>+ Impostos:</div>
              <div class="col-4">
                <span>{{ pedido.impostos | currency : "BRL" }}</span>
              </div>
            </div>
            <div *ngIf="pedido.freteValor" class="row mb-1" style="color: red">
              <div class="col-8 text-right" i18n>+ Frete:</div>
              <div class="col-4">
                <span>{{ pedido.freteValor | currency : "BRL" }}</span>
              </div>
            </div>
            <div class="row mb-1 pl-0">
              <div class="col-8 text-right pl-0" i18n>Valor total:</div>
              <div class="col-4 pl-0" style="color: green; font-weight: bold">
                {{ pedido.total | currency : "BRL" }}
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-5"></div>
          <div class="col-sm-7"></div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="mt-2" [innerHtml]="tablePedidoView"></div>
            <!--<div class="mt-2">
                          <simple-html [html]="tablePedidoView"></simple-html>
                      </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade"
  id="pedidoModalInfo"
  tabindex="-1"
  role="dialog"
  aria-labelledby="pedidoModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div *ngIf="pedido" class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>Pedido #{{ pedido.pedido }} - Informações</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding: 5px !important">
        <div class="row mt-2">
          <div class="col-sm-4 pr-0">
            <label>Id ERP</label><br />
            {{ pedido.infos[pedido.infos.length - 1].idErp }}
          </div>
          <div class="col-sm-8">
            <label i18n>Código ERP</label><br />
            {{ pedido.infos[pedido.infos.length - 1].codigoErp }}
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="row mt-2">
          <div class="col-sm-4 pr-0">
            <label>NFS</label><br />
            {{ pedido.infos[pedido.infos.length - 1].nfs }}
          </div>
          <div class="col-sm-8">
            <label>Chave NFE</label><br />
            {{ pedido.infos[pedido.infos.length - 1].chaveNfe }}
          </div>
        </div>
        <hr class="mt-2 mb-2" />
        <div class="row mt-2">
          <div class="col-sm-4">
            <label>Status</label><br />
            {{ pedido.infos[pedido.infos.length - 1].statusDescricao }}
          </div>
          <div class="col-sm-8">
            <label i18n>Número Objeto</label><br />
            {{ pedido.infos[pedido.infos.length - 1].numeroObjeto }}
          </div>
        </div>
        <div class="row">
          <div class="col-12 pt-2">
            <div class="table-responsive">
              <table
                class="table table-hover table-condensed table-striped table-sm table-responsive-xs"
              >
                <thead class="table-head">
                  <tr>
                    <th><label i18n>Data</label></th>
                    <th><label i18n>Status</label></th>
                    <th><label i18n>NFS</label></th>
                    <th><label i18n>Chave NFE</label></th>
                    <th><label i18n>Número Objeto</label></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let info of pedido.infos">
                    <td>{{ info.data }}</td>
                    <td>{{ info.statusDescricao }}</td>
                    <td>{{ info.nfs }}</td>
                    <td style="font-size: 0.6rem">{{ info.chaveNfe }}</td>
                    <td>{{ info.numeroObjeto }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade"
  id="confirmDelModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="confirmDelModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>Deseja realmente excluir?</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-footer">
        <button
          (click)="deletePedido()"
          type="button"
          data-dismiss="modal"
          class="btn btn-outline-primary"
        >
          Ok
        </button>
        <button type="button" data-dismiss="modal" class="btn btn-primary" i18n>
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade"
  id="confirmCopyModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="confirmDelModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>Deseja realmente copiar este pedido?</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-footer">
        <button
          (click)="copyPedido()"
          type="button"
          data-dismiss="modal"
          class="btn btn-outline-primary"
        >
          Ok
        </button>
        <button type="button" data-dismiss="modal" class="btn btn-primary">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal fade"
  id="printPedidoModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="boletoModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 *ngIf="pedido" class="modal-title" i18n>Pedido #{{ pedido.pedido }}</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body"></div>
    </div>
  </div>
</div>
